import script from "./RedGreenCartModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./RedGreenCartModal.vue?vue&type=script&lang=ts&setup=true"

import "./RedGreenCartModal.vue?vue&type=style&index=0&id=a2d7835a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2d7835a"]])

export default __exports__